<ms-scroll-adapter *ngIf="banners?.length" [alwaysShowArrows]="!isMobile">
    <ul class="center ms-racing-promo-banner">
        <li class="promo-card card card-with-img" *ngFor="let banner of banners; let promoIndex = index" [attr.data-index]="promoIndex">
            <a
                *ngIf="!banner.showHtmlContents && banner.imageUrl"
                [href]="banner.href"
                [attr.target]="banner.target"
                (click)="trackBannerClicked(banner, promoIndex)">
                <div class="card-special-image" *ngIf="banner.imageUrl" [style.background-image]="banner.imageUrl | msToCssUrl"></div>
            </a>
            <div *ngIf="banner.showHtmlContents && banner.htmlContents" [innerHTML]="banner.htmlContents | msTrust: 'html'"></div>
        </li>
    </ul>
</ms-scroll-adapter>
